import React from 'react'

const RadioField = ({ field, id, label, ...props }) => {
  const { text, radioValue } = props
  const { name, onChange, onBlur, value } = field
  return (
    <div className="flex mr-1 relative">
      <input
        name={name}
        id={id}
        type="radio"
        value={radioValue}
        checked={radioValue === value}
        onChange={onChange}
        onBlur={onBlur}
      />
      <label className="flex items-center cursor-pointer text-lg" htmlFor={id}>
        {text}
      </label>
    </div>
  )
}

export default RadioField
